<template lang="pug">
.card-view(@click="onClick" :class="active? 'active': ''")
  //.card-shadow
    img(src="~assets/card-shadow.png")
  blue-shadow  
  .card(ref="card")
    .banner
      img(:src="content.banner")
    .copy
      .title  {{content.title}}
      .subtitle {{content.subtitle}}
    .body {{content.body}}
      //.figure
        img(src="~assets/banner1.png")
  
</template>
<script>
import { mapGetters } from 'vuex'
import gsap from 'gsap'
import BlueShadow from '@/components/wedgits/BlueShadow'
export default {
  name: 'CardView',
  components: { BlueShadow },
  props: {
    active: {},
    content: {},
  },
  computed: {},
  data() {
    return {
      state: 0,
      clone: null,
    }
  },
  watch: {
    active(val) {
      if (val) {
        this.toState1()
      } else {
        this.toState0()
      }
    },
  },
  methods: {
    ...mapGetters('app', ['getSysBarHeight']),
    onClick() {
      this.$emit('clicked')
    },
    toState0() {
      this.clone.classList.remove('active')
      gsap.to(this.clone, {
        width: this.rect.width,
        height: this.rect.height,
        x: 0,
        y: 0,
        duration: 0.3,
        ease: 'power3',
        onComplete: () => {
          this.$el.style.opacity = 1
          document.body.removeChild(this.clone)
          this.clone = null
        },
      })
    },
    toState1() {
      this.clone = this.$refs.card.cloneNode(true)
      this.rect = this.$refs.card.getBoundingClientRect()
      this.sysTop = this.getSysBarHeight()
      this.clone.style.position = 'fixed'
      this.clone.style.zIndex = 999
      //this.clone.style.background = 'red'
      this.clone.style.top = this.rect.top + 'px'
      this.clone.style.left = this.rect.left + 'px'
      this.clone.style.width = this.rect.width + 'px'
      this.clone.style.height = this.rect.height + 'px'
      this.clone.addEventListener('click', this.onClick)
      document.body.appendChild(this.clone)
      this.clone.classList.add('active')
      this.$el.style.opacity = 0
      gsap.to(this.clone, {
        width: window.innerWidth,
        height: window.innerHeight - this.sysTop,
        x: -this.rect.left,
        y: -this.rect.top + this.sysTop,
        duration: 0.5,
        ease: 'back.out(2)',
        onComplete: () => {},
      })
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "../../styles/common"
.card-view
  width: 100%
  height: 100%
  //.card-shadow
    position: absolute
    width: pxToRem(612)
    height: pxToRem(190)
    left: pxToRem(-15)
    bottom: pxToRem(-60)
    z-index: -1
    opacity: 1
    img
      width: 100%

.card
  background: #ffffff
  width: 100%
  height: 100%
  border-radius: pxToRem(16)
  overflow: hidden
  box-shadow: 0 pxToRem(-1) pxToRem(10) 0 rgba(226,226,226,0.73)
  //transition: all 0.5s ease
  &.active
    border-radius: 0
    .banner
      img
        width: 100%
        height: 100%
    .copy
      height: pxToRem(150)
      .subtitle
        height: 0
        opacity: 0
  .banner
    width: 100%
    height: pxToRem(582)
    //background: #1664FF
    overflow: hidden
    display: flex
    align-items: center
    justify-content: center
    img
      //width: 100%
      height: 100%
      object-fit: cover
  .copy
    transition: all 0.5s ease
    width: 100%
    height: pxToRem(368)
    background: #ffffff
    color: black
    display: flex
    justify-content: center
    align-items: start
    flex-direction: column
    padding-left: pxToRem(42)
    padding-right: pxToRem(42)
    .title
      font-size: pxToRem(54)
    .subtitle
      font-size: pxToRem(26)
      color: #999999
  .body
    width: 100%
    transform-origin: center
    padding: pxToRem(40)
    animation-name: fadeIn
    animation-fill-mode: both
    animation-duration: 0.3s
    animation-delay: 0.2s
    animation-timing-function: ease
    //.summary
      font-size: pxToRem(26)
      color: #999999
      width: 100%
    //.figure
      width: 100%
      img
        width: 100%
@keyframes fadeIn
  0%
    transform: translateY(10%)
    opacity: 0
  100%
    transform: translateY(0)
    opacity: 1
</style>
